import styled from 'styled-components'
import {StyledButton} from "components/Buttons/DefaultButton/DefaultButton.styles"

export const Page = styled.div`
    height: 100%;
    width: 100%;
    background: url('images/Mask_group.svg');
    background-size: cover;
`

export const ChangeRoleBlock = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
    
    a {
        text-decoration: underline;
        cursor: pointer;
        text-align: center;
    }
`

export const NameBlock = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;

    @media only screen and (max-width: 400px) {
        flex-direction: column;
    }
`

export const InputPhoneBlock = styled.div`
    display: flex;
    flex-direction: row;
    max-width: 50%;

    @media only screen and (max-width: 400px) {
        max-width: 100%;
    }
`

export const ContinueButton = styled(StyledButton)`
    max-width: 24rem;
    align-self: center;

    @media only screen and (min-width: 900px) {
        margin-top: 2rem !important;
    }
`

export const Container = styled.div`
  overflow: auto;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: val(--primary-contrast);
  align-items: center;
  height: 100%;

  .inset {
    margin: 0 0 1rem;
    font-size:13px;
  }

  .halfWidth {
    max-width: 50%;
  }

  .headerCountrySelect {
    color: #000;
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5rem; /* 150% */
    letter-spacing: 0.15px;
  }

  .countrySelectBox {
    display: flex;
    flex-direction: column;
  }

  .resumeInput {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    color: var(--labels-primary);
    font-size: var(--typography-h5-size);
    align-items: center;
    padding: var(--boundvariablesdata);
    gap: var(--boundvariablesdata);
    border-radius: var(--borderRadius, 8px);
    border: 1px dashed var(--secondary-main, #0B4598);
    overflow-wrap: anywhere;
  }
  
  .candidates-who-do,
  .upload-resum {
    text-align: center;
  }
  
  .upload-resum {
    font-weight: 600;
    font-family: var(--fontMain);
    font-size: 1.125rem;
    font-style: normal;
    line-height: 1.625rem;
    letter-spacing: 0.46px;
  }
  
  .candidates-who-do {
    color: var(--text-secondary, rgba(0, 0, 0, 0.60));
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;
    flex: 1;
    font-size: var(--typography-body2-size);
    letter-spacing: 0.17px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.25rem;
  }
  
  .cloud-upload-outline-icon {
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    overflow: hidden;
    flex-shrink: 0;
  }
`

export const MarketingSourceBlock = styled.div`
    margin-top: 16px;
    
    .MuiFormControl-root {
        width: 100%;
    }

    .error-text {
        color: var(--error-main);
        margin-left: 14px;
        margin-right: 14px;
        font-size: var(--input-helper-size);
        margin-top: 3px;
    }
`;
